<template>
    <div class="container" style="font-size: 16px">
        <div style="display:flex; align-items: center;margin-bottom: 20px;">
            <span>餐厅选择：</span>
            <el-select @change="change" clearable v-model="dining_id" placeholder="请选择">
                <el-option
                        v-for="item in diningList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </div>
        <div class="line"></div>
        <div>
            <span>餐厅名称：</span>
            <span>{{dinner_name}}</span>
        </div>
        <div style="display: flex;margin-top: 30px;">
            <span>选择餐厅情况：</span>
            <el-radio-group v-model="dining_situations">
                <el-radio border label="2" style="display: block; margin-left: 10px; margin-bottom: 15px;width: 70%">餐位充足</el-radio>
                <el-radio border label="3" style="display: block; margin-bottom: 15px;width: 70%">少量餐位</el-radio>
                <el-radio border label="4" style="display: block; margin-bottom: 15px;width: 70%">餐位不足</el-radio>
                <el-radio border label="5" style="display: block; margin-bottom: 15px;width: 70%">就餐拥堵</el-radio>
                <el-radio border label="0" style="display: block; margin-bottom: 15px; width: 70%">未营业</el-radio>
            </el-radio-group>
        </div>
        <div style="margin-top: 20px;margin-left: 40px;">
            <el-button @click="cancel()">取 消</el-button>
            <el-button style="margin-left: 20px;" type="primary" @click="submit()">确 定</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "info",
        data() {
            return {
                diningList: [],
                dining_id: '',
                dining_situations: '',
                dinner_name: ''
            }
        },
        created() {
            this.getDiningList();
        },
        methods: {
            change(val) {
                this.diningList.forEach(item=>{
                    if(val === item.id) {
                        this.dinner_name = item.name
                    }
                })
            },
            getDiningList() {
                this.$api.post(this.$apiUrl.dinnerList,{school_id: localStorage.getItem('schoolId')},(res)=>{
                    this.diningList = res.data
                    this.dining_id = res.data[0].id
                    this.dinner_name = res.data[0].name
                })
            },
            submit() {
                if(this.dining_id == '') {
                    return this.$message.warning('请选择餐厅')
                }
                if(this.dining_situations == '') {
                    return this.$message.warning('请选择餐厅情况')
                }
                let params = {
                    id: this.dining_id,
                    school_id: localStorage.getItem('schoolId'),
                    dining_situations: this.dining_situations,
                    operator: this.$store.getters.username
                }
                this.$api.post(this.$apiUrl.dinnerModify,params,(res)=>{
                    this.getDiningList();
                    this.dining_situations = '';
                    this.$message.success('提交成功')
                })
            },
            cancel() {
                this.getDiningList();
                this.dining_situations = '';
                this.$message.info('已取消')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// info.vue?f344a38a